var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"delivery-route-taxi"},[_vm._v("Доставка маршрутным такси.")])
}
var staticRenderFns = []

export { render, staticRenderFns }